var TokenKey = 'Hikkan-Token';
var CMTokenKey = 'Hikcloud-Token'; // 当前用户所关联法庭类型的数字字典

var CommonInfo = 'Common-Info'; // 法庭类型相关的数据字典

var AllCommonInfo = 'All-Common-Info';
export default {
  getToken: function getToken() {
    return sessionStorage.getItem(TokenKey);
  },
  setToken: function setToken(token) {
    return sessionStorage.setItem(TokenKey, token);
  },
  removeToken: function removeToken() {
    return sessionStorage.removeItem(TokenKey);
  },
  getCMToken: function getCMToken() {
    return sessionStorage.getItem(CMTokenKey);
  },
  setCMToken: function setCMToken(token) {
    return sessionStorage.setItem(CMTokenKey, token);
  },
  removeCMToken: function removeCMToken() {
    return sessionStorage.removeItem(CMTokenKey);
  },
  getCommonInfo: function getCommonInfo() {
    var commonInfo = sessionStorage.getItem(CommonInfo);

    if (commonInfo) {
      return JSON.parse(commonInfo);
    }

    return '';
  },
  setCommonInfo: function setCommonInfo(token) {
    return sessionStorage.setItem(CommonInfo, JSON.stringify(token));
  },
  removeCommonInfo: function removeCommonInfo() {
    return sessionStorage.removeItem(CommonInfo);
  },
  getAllCommonInfo: function getAllCommonInfo() {
    var allCommonInfo = sessionStorage.getItem(AllCommonInfo);

    if (allCommonInfo) {
      return JSON.parse(allCommonInfo);
    }

    return '';
  },
  setAllCommonInfo: function setAllCommonInfo(token) {
    return sessionStorage.setItem(AllCommonInfo, JSON.stringify(token));
  },
  removeAllCommonInfo: function removeAllCommonInfo() {
    return sessionStorage.removeItem(AllCommonInfo);
  }
};